import { defineComponent as p, mergeModels as m, useModel as v, useTemplateRef as D, onBeforeMount as M, onMounted as y, onBeforeUnmount as B, watch as d, nextTick as o, createElementBlock as C, openBlock as k, mergeProps as F } from "vue";
import { install as O } from "./index.js";
const x = /* @__PURE__ */ p({
  __name: "SchemasteryFormVue",
  props: /* @__PURE__ */ m({
    schema: {},
    value: {},
    validateOnChange: { type: Boolean, default: !1 }
  }, {
    schema: { required: !0 },
    schemaModifiers: {},
    value: { required: !1, default: {} },
    valueModifiers: {}
  }),
  emits: /* @__PURE__ */ m(["change"], ["update:schema", "update:value"]),
  setup(i, { expose: c, emit: h }) {
    const u = v(i, "schema"), r = v(i, "value"), g = h, a = D("elRef");
    let n = !1, l = !1;
    const f = (e) => {
      if (l)
        return;
      const t = a.value, s = i.validateOnChange ? t.getData({ validate: !0 }) : e.detail.state;
      n = !0, r.value = s, o(() => {
        n = !1;
      }), g("change", e.detail);
    };
    return M(() => {
      O();
    }), y(() => {
      const e = a.value;
      u.value && (e.schema = u.value), r.value !== void 0 && e.setData(r.value, { validate: !1, autofix: !0 }), e.addEventListener("form-change", f);
    }), B(() => {
      a.value?.removeEventListener("form-change", f);
    }), d(
      u,
      (e) => {
        n || a.value && e && a.value.schema !== e && (l = !0, a.value.schema = e, o(() => {
          l = !1;
        }));
      },
      { deep: !0, immediate: !0 }
    ), d(
      r,
      (e) => {
        if (n || !a.value || e === void 0) return;
        const t = a.value.getData({ validate: !1 });
        JSON.stringify(t) !== JSON.stringify(e) && (l = !0, a.value.setData(e, { validate: !1 }), o(() => {
          l = !1;
        }));
      },
      { deep: !0, immediate: !0 }
    ), c({
      /** 手动设置数据并可选择是否触发 v-model:data */
      setData(e, t) {
        const s = a.value;
        s.setData(e, { validate: !!t?.validate }), t?.emit && (r.value = s.getData({ validate: !!t?.validate }));
      },
      /** 获取数据 */
      getData(e) {
        return a.value.getData(e);
      },
      /** 设置 schema，并同步到 v-model:schema */
      setSchema(e, t = !0) {
        a.value.schema = e, t && (u.value = e);
      },
      refresh() {
        a.value.refresh();
      },
      reset() {
        a.value.reset();
      },
      /** 原生元素 */
      el: a
    }), (e, t) => (k(), C("schema-form", F({
      ref_key: "elRef",
      ref: a
    }, e.$attrs), null, 16));
  }
});
export {
  x as default
};
//# sourceMappingURL=vue.js.map
